<template>
  <div>
    <ItemSetting v-if="showConfig('color')" label="字体颜色">
      <el-color-picker v-model="color" show-alpha></el-color-picker>
    </ItemSetting>

    <ItemSetting v-if="showConfig('fontFamily')" label="字体">
      <el-select v-model="fontFamily" placeholder="请选择字体" size="small">
        <el-option v-for="font in fontFamilyList" :key="font.value" :label="font.label" :value="font.value"
          :style="{ fontFamily: font.value }">
          <span :style="{ fontFamily: font.value }">{{ font.label }}</span>
        </el-option>
      </el-select>
    </ItemSetting>

    <ItemSetting v-if="showConfig('fontSize')" label="字体大小">
      <el-select v-model="fontSize" placeholder="请选择大小" size="small">
        <el-option v-for="size in fontSizeList" :key="size.value" :label="size.label" :value="size.value">
          <span :style="{ fontSize: size.value }">{{ size.label }}</span>
        </el-option>
      </el-select>
    </ItemSetting>

    <ItemSetting v-if="showConfig('fontWeight')" label="字体粗细">
      <el-select v-model="fontWeight" placeholder="请选择粗细" size="small">
        <el-option v-for="weight in fontWeightList" :key="weight.value" :label="weight.label" :value="weight.value">
          <span :style="{ fontWeight: weight.value }">{{ weight.label }}</span>
        </el-option>
      </el-select>
    </ItemSetting>

    <ItemSetting v-if="showConfig('lineHeight')" label="字体行高">
      <el-select v-model="lineHeight" placeholder="请选择行高" size="small">
        <el-option v-for="height in lineHeightList" :key="height.value" :label="height.label" :value="height.value">
          <span :style="{ lineHeight: height.value }">{{ height.label }}</span>
        </el-option>
      </el-select>
    </ItemSetting>
  </div>
</template>

<script>
import ItemSetting from './ItemSetting.vue'
import editMixin from '../mixins/editMixin';

export default {
  name: 'FontSetting',
  mixins: [editMixin],  
  components: {
    ItemSetting
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        fontFamily: '',
        fontSize: '',
        fontWeight: '',
        color: '',
        lineHeight: ''
      })
    },
    configs: {
      type: [Array],
      default: () => ['color', 'fontFamily', 'fontSize', 'fontWeight', 'lineHeight']
    }
  },
  data() {
    return {
      fontFamilyList: [
        { label: '微软雅黑', value: 'Microsoft YaHei' },
        { label: '宋体', value: 'SimSun' },
        { label: '黑体', value: 'SimHei' },
        { label: '楷体', value: 'KaiTi' },
        { label: 'Arial', value: 'Arial' },
        { label: 'Helvetica', value: 'Helvetica' },
        { label: 'Times New Roman', value: 'Times New Roman' },
        { label: 'Verdana', value: 'Verdana' }
      ],
      fontSizeList: [
        { label: '10px', value: '10px' },
        { label: '12px', value: '12px' },
        { label: '14px', value: '14px' },
        { label: '16px', value: '16px' },
        { label: '18px', value: '18px' },
        { label: '20px', value: '20px' },
        { label: '22px', value: '22px' },
        { label: '24px', value: '24px' },
        { label: '28px', value: '28px' },
        { label: '32px', value: '32px' },
        { label: '36px', value: '36px' },
        { label: '40px', value: '40px' }
      ],
      fontWeightList: [
        { label: '100', value: '100' },
        { label: '200', value: '200' },
        { label: '300', value: '300' },
        { label: '400', value: '400' },
        { label: '500', value: '500' },
        { label: '600', value: '600' },
        { label: '700', value: '700' },
        { label: '800', value: '800' },
        { label: '900', value: '900' }
      ],
      lineHeightList: [
        { label: '1.0', value: '1.0' },
        { label: '1.1', value: '1.1' },
        { label: '1.2', value: '1.2' },
        { label: '1.3', value: '1.3' },
        { label: '1.4', value: '1.4' },
        { label: '1.5', value: '1.5' },
        { label: '1.6', value: '1.6' },
        { label: '1.7', value: '1.7' },
        { label: '1.8', value: '1.8' },
        { label: '1.9', value: '1.9' },
        { label: '2.0', value: '2.0' }
      ]
    }
  },
  methods: {
    showConfig(config) {
      if (this.configs === 'all') {
        return true
      }
      if (Array.isArray(this.configs)) {
        return this.configs.includes(config)
      }
      return false
    }
  },
  computed: {
    fontFamily: {
      get() {
        return this.value.fontFamily
      },
      set(val) {
        this.updateValue({ fontFamily: val })
      }
    },
    fontSize: {
      get() {
        return this.value.fontSize
      },
      set(val) {
        this.updateValue({ fontSize: val })
      }
    },
    fontWeight: {
      get() {
        return this.value.fontWeight
      },
      set(val) {
        this.updateValue({ fontWeight: val })
      }
    },
    color: {
      get() {
        return this.value.color
      },
      set(val) {
        this.updateValue({ color: val })
      }
    },
    lineHeight: {
      get() {
        return this.value.lineHeight
      },
      set(val) {
        this.updateValue({ lineHeight: val })
      }
    }
  },
}
</script>

<style lang="scss" scoped></style>
